/** 
 Copyright Highway9 Networks Inc. 
 */ 

import { Types } from "~/constants/types";
import evt from "../event";
import { WebSocketMessage } from "~/types/WebsocketMessage";

// Dev-only: logging full objects every WebSocket flush makes DevTools retain them (MCS-3969).
const DEBUG_EVENTS = import.meta.env.DEV;

export function socketRefreshHandler(type: string, patches: WebSocketMessage[]) {
  // Patches are coalesced and merged in the events WebSocket worker before postMessage.

  if (DEBUG_EVENTS) {
    console.log("Processing event", type, patches.map(d => `${d.objectId} : ${d.eventType} (${d.updateEventType})`));
    console.log("[Patches]", patches);
  }

  switch (type) {
    case Types.radio:
      evt.emit('refreshRadios', patches)
      break;
    case Types.site:
      evt.emit('refreshSites', patches)
      break;
    case Types.radioGroup:
      evt.emit('refreshRadioGroups', patches)
      break;

    case Types.device:
      evt.emit('refreshDevices', patches)
      break;
    case Types.deviceGroup:
      evt.emit('refreshDeviceGroups', patches)
      break;

    case Types.edge:
      evt.emit('refreshEdges', patches)
      break;
    case Types.cgwEdge:
      evt.emit('refreshEdges', patches)
      break;
    case Types.edgePool:
      evt.emit('refreshEdgePools', patches)
      break;

    case Types.walkTest:
      evt.emit('refreshWalkTests', patches)
      break;

    // Admin Pages Objects
    case Types.network:
      evt.emit('refreshNetwork', patches)
      break;

    case Types.accessConfig:
      evt.emit('refreshAccessConfig', patches)
      break;

    case Types.defaultRadioManager:
      evt.emit('refreshDefaultRadioManager', patches)
      break;


    case Types.user:
      evt.emit('refreshUsers', patches)
      break;

    case Types.caCert:
      evt.emit('refreshCACert', patches)
      break;
    
    case Types.settings:
      evt.emit('refreshSettings', patches)
      break;
    
    case Types.radioGlobalConfig:
      evt.emit('refreshRadioGlobalConfig', patches)
      break;

    case Types.supportChannel:
      evt.emit('refreshSupportChannel', patches)
      break;
    case Types.apiToken:
      evt.emit('refreshApiToken', patches)
      break;

    // Profile Objects
    case Types.mobilityProfile:
      evt.emit('refreshMobilityProfiles', patches)
      break;

    case Types.clockPool:
      evt.emit('refreshClockPools', patches)
      break;

    case Types.clock:
      evt.emit('refreshClocks', patches)
      break;

    case Types.monitoringSystem:
      evt.emit('refreshMonitoringSystem', patches)
      break;
    
    case Types.aaaServerProfile:
      evt.emit('refreshAAAProfiles', patches)
      break;

    case Types.alertProfile:
      evt.emit('refreshAlertProfiles', patches)
      break;

    case Types.simulatorAppliance:
      evt.emit('refreshSimulator', patches)
      break;
    case Types.ueSimulator:
      evt.emit('refreshUESimulators', patches)
      break;

    case Types.dnn:
      evt.emit('refreshDNN', patches)
      break;

    case Types.qosProfile:
      evt.emit('refreshQOSProfile', patches)
      break;

    case Types.application:
      evt.emit('refreshPolicy', patches)
      break;
    case Types.virtualMobilityZone:
      evt.emit('refreshVMZone', patches)
      break;
    case Types.zoneGroup:
      evt.emit('refreshZoneGroup', patches)
      break;

    case Types.hardware:
      evt.emit('refreshHardware', patches)
      break;
    
    case Types.metricsTemplate:
      evt.emit('refreshMetricsTemplate', patches)
      break;

    case Types.operator:
      evt.emit('refreshOperators', patches)
      break;
    case Types.operatorRadio:
      evt.emit('refreshOperatorRadios', patches)
      break;

    case Types.operation:
      patches.forEach((d) => {
        evt.emit('operations', d.objectId, d);
      });
      break;

    default:
      if (type.startsWith('mno')) {
        evt.emit('refreshOperators');
      } else {
        console.warn(
          "[socketRefreshHandler] Unhandled websocket objectType",
          type,
          patches.map((patch) => ({
            objectId: patch.objectId,
            eventType: patch.eventType,
            updateEventType: patch.updateEventType,
          })),
        );
      }
      break;
  }

}